import { apiFunction } from "../../../apiCalls/function";
import * as APIs from "../../../apiCalls/urls/officer/urls";


export const addSchoolImage = async (data) => {
    return await apiFunction(APIs.ADD_SCHOOL_IMAGE, "post", data, true, "admin")
}

export const getSchoolUploadHistory = async (params) => {
    return await apiFunction(APIs.SCHOOL_UPLOAD_HISTORY + "?" + new URLSearchParams(params).toString(), "get", null, true, "admin")
}
